import { Link, NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { LogOut, User as UserIcon, Sparkles } from "lucide-react";

export default function Nav() {
  const { user, logout } = useAuth();
  const nav = useNavigate();

  const onLogout = () => {
    logout();
    nav("/");
  };

  return (
    <header
      className="sticky top-0 z-40 backdrop-blur-xl"
      style={{ background: "rgba(5,5,5,0.7)", borderBottom: "1px solid var(--border)" }}
      data-testid="top-nav"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 md:px-12 h-16 flex items-center justify-between">
        <Link to="/" className="flex items-center gap-2" data-testid="nav-logo">
          <span className="font-display font-black text-lg tracking-tighter">
            AI <span style={{ color: "var(--ai)" }}>vs</span> HUMAN
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-10">
          <NavLink to="/challenges" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid="nav-challenges">
            Challenges
          </NavLink>
          <NavLink to="/store" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid="nav-store">
            Store
          </NavLink>
          <NavLink to="/leaderboard" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid="nav-leaderboard">
            Leaderboard
          </NavLink>
          {user?.role === "admin" && (
            <NavLink to="/admin" className={({ isActive }) => `nav-link ${isActive ? "active" : ""}`} data-testid="nav-admin">
              Admin
            </NavLink>
          )}
        </nav>

        <div className="flex items-center gap-3">
          {user ? (
            <>
              {user.is_pro && (
                <span className="tag tag-ai hidden sm:inline-flex items-center gap-1" data-testid="nav-pro-badge">
                  <Sparkles size={10}/> PRO
                </span>
              )}
              <Link to="/profile" className="hidden sm:flex items-center gap-2 nav-link" data-testid="nav-profile">
                <UserIcon size={14} /> {user.name}
              </Link>
              <button className="btn btn-secondary" onClick={onLogout} data-testid="nav-logout-button">
                <LogOut size={14} /> Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login" className="nav-link" data-testid="nav-login">Login</Link>
              <Link to="/register" className="btn btn-primary" data-testid="nav-register-button">Sign up</Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
